if (!customElements.get('cart-discount')) {
  class CartDiscount extends HTMLElement {
    constructor() {
      super();
      this.sessionStorageCodeKey = 'cart-discount-last-used-code';
      this.sessionStorageParentKey = 'cart-discount-last-used-parent';
    }

    connectedCallback() {
      if (window.SHOPIFY_STOREFRONT_API_URL == null || window.SHOPIFY_STOREFRONT_ACCESS_TOKEN == null) {
        return;
      }

      this.cartId = null;
      this.discounts = [];
      this.getCurrentCart();
    }

    init() {
      this.form = this.querySelector('form');
      if (!this.form) return;
      this.input = this.form.querySelector('input');
      this.submitButton = this.form.querySelector('button');
      if (!this.input || !this.submitButton) return;
      this.removeAllButton = this.querySelector('.cart-discount__remove-all');
      this.cart = document.querySelector('cart-drawer-items') || this.querySelector('cart-items');
      this.errorElement = document.querySelectorAll(`.cart-discount__error`);
      this.discountWrapper = this.querySelector('.discounts');
      this.discountTemplate = this.querySelector('template.discount-template');
      this.bindRemoveDiscount = this.removeDiscount.bind(this);

      this.style.setProperty('--button-width', `${Math.ceil(this.submitButton.getBoundingClientRect().width)}px`);

      this.setRemoveButtons();

      this.form.addEventListener('submit', this.onFormSubmit.bind(this));
      if (this.removeAllButton) this.removeAllButton.addEventListener('click', this.removeAllDiscounts.bind(this));
      this.classList.remove('hidden');
    }

    getCurrentCart() {
      fetch(`${Shopify.routes.root}cart.js`)
        .then((response) => {
          return response.json();
        })
        .then((state) => {
          this.cartToken = state.token;
          this.cartId = this.cartToken.split('?')[0];

          this.getCurrentDiscounts();
        })
        .catch((err) => {
          console.error('[CART-DISCOUNT]', err);
        });
    }

    getCurrentDiscounts() {
      const query = `
        query {
          cart(id: "gid://shopify/Cart/${this.cartToken}") {
            id
            discountCodes {
              code
              applicable
            }
          }
        }
      `;

      fetch(window.SHOPIFY_STOREFRONT_API_URL, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Shopify-Storefront-Access-Token': window.SHOPIFY_STOREFRONT_ACCESS_TOKEN,
        },
        body: JSON.stringify({ query }),
      })
        .then((response) => response.json())
        .then((state) => {
          const discountCodes = state.data.cart.discountCodes || [];
          if (discountCodes && discountCodes.length > 0) {
            discountCodes.map((discount) => {
              if (discount.applicable) {
                this.discounts.push(this.filterCodeValue(discount.code));
              }
            });
          }

          this.init();
          this.checkDiscountApplication();
        })
        .catch((err) => {
          console.error(err);
        });
    }

    updateDiscounts(discounts) {
      const query = `
        mutation {
          cartDiscountCodesUpdate(cartId: "gid://shopify/Cart/${this.cartToken}", discountCodes: ${JSON.stringify(
        discounts
      )}) {
            cart {
              id
              discountCodes {
                code
                applicable
              }
            }
            userErrors {
              code
              field
              message
            }
          }
        }
      `;

      fetch(window.SHOPIFY_STOREFRONT_API_URL, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Shopify-Storefront-Access-Token': window.SHOPIFY_STOREFRONT_ACCESS_TOKEN,
        },
        body: JSON.stringify({ query }),
      })
        .then((response) => response.json())
        .catch((err) => {
          console.error(err);
          if (this.errorElement) {
            this.errorElement.textContent = window.cartStrings.discountError;
          }
        })
        .finally(() => {
          this.cart.onCartUpdate();
          this.setLoadingForm(false);
        });
    }

    onFormSubmit(event) {
      event.preventDefault();
      this.setLoadingForm(true);
      const newDiscount = this.filterCodeValue(this.form.querySelector('input').value);

      sessionStorage.setItem(this.sessionStorageCodeKey, this.form.querySelector('input').value);
      sessionStorage.setItem(this.sessionStorageParentKey, this.dataset.parentSelector);
      const discountCodes = [...this.discounts, newDiscount];

      this.updateDiscounts(discountCodes);
    }

    removeDiscount(event) {
      event.preventDefault();
      this.setLoadingForm(true);

      const code = this.filterCodeValue(event.currentTarget.dataset.code);
      const discountCodes = this.discounts.filter((discount) => discount !== code);

      sessionStorage.removeItem(this.sessionStorageCodeKey);
      sessionStorage.removeItem(this.sessionStorageParentKey);
      this.newDiscount = null;

      this.updateDiscounts(discountCodes);
    }

    removeAllDiscounts(event) {
      event.preventDefault();
      this.setLoadingForm(true);

      sessionStorage.removeItem(this.sessionStorageCodeKey);
      sessionStorage.removeItem(this.sessionStorageParentKey);

      this.updateDiscounts([]);
    }

    checkDiscountApplication() {
      const lastAppliedDiscount = sessionStorage.getItem(this.sessionStorageCodeKey);
      const parentSelector = sessionStorage.getItem(this.sessionStorageParentKey);
      const errorElement = document.querySelector(`${parentSelector ? parentSelector : ''} .cart-discount__error`);

      if (lastAppliedDiscount) {
        if (!this.discounts.includes(this.filterCodeValue(lastAppliedDiscount)) && errorElement) {
          errorElement.innerHTML = window.cartStrings.discountInvalidCode.replace('[code]', lastAppliedDiscount);
        }
        requestAnimationFrame(() => {
          sessionStorage.removeItem(this.sessionStorageCodeKey);
          sessionStorage.removeItem(this.sessionStorageParentKey);
        });
      }

      if (this.discountTemplate && this.discountWrapper) {
        this.unsetRemoveButtons();

        this.discounts.forEach((discount) => {
          if (!this.shownDiscountCodes.includes(this.filterCodeValue(discount))) {
            const clone = this.discountTemplate.content.cloneNode(true);
            const item = clone.querySelector('.discount-template-wrapper');
            item.innerHTML = item.innerHTML.replace(/\[code\]/g, discount);
            this.discountWrapper.appendChild(item.querySelector('.discounts__discount'));
          }
        });

        this.setRemoveButtons();
      }
    }

    setRemoveButtons() {
      this.removeDiscountButtons = this.querySelectorAll('.discount--remove');
      this.shownDiscountCodes = Array.from(this.removeDiscountButtons).map((button) =>
        this.filterCodeValue(button.dataset.code)
      );

      this.removeDiscountButtons.forEach((button) => {
        button.addEventListener('click', this.bindRemoveDiscount);
      });
    }

    unsetRemoveButtons() {
      this.removeDiscountButtons.forEach((button) => {
        button.addEventListener('click', this.bindRemoveDiscount);
      });
    }

    setLoadingForm(disable) {
      if (disable) {
        this.submitButton.setAttribute('disabled', true);
        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.submitButton.querySelector('.loading__spinner').classList.remove('hidden');

        if (this.removeAllButton) this.removeAllButton.setAttribute('disabled', true);
        if (this.removeAllButton) this.removeAllButton.setAttribute('aria-disabled', true);

        this.input.setAttribute('disabled', true);
        this.input.setAttribute('aria-disabled', true);

        this.removeDiscountButtons.forEach((button) => {
          button.setAttribute('disabled', true);
          button.setAttribute('aria-disabled', true);
        });
      } else {
        this.submitButton.removeAttribute('disabled');
        this.submitButton.removeAttribute('aria-disabled');
        this.submitButton.classList.remove('loading');
        this.submitButton.querySelector('.loading__spinner').classList.add('hidden');

        if (this.removeAllButton) this.removeAllButton.removeAttribute('disabled');
        if (this.removeAllButton) this.removeAllButton.removeAttribute('aria-disabled');

        this.input.removeAttribute('disabled');
        this.input.removeAttribute('aria-disabled');

        this.removeDiscountButtons.forEach((button) => {
          button.removeAttribute('disabled');
          button.removeAttribute('aria-disabled');
        });
      }
    }

    filterCodeValue(code) {
      return code.trim().toLowerCase();
    }
  }

  customElements.define('cart-discount', CartDiscount);
}